import script from "./reviews.vue?vue&type=script&setup=true&lang=js"
export * from "./reviews.vue?vue&type=script&setup=true&lang=js"

import "./reviews.vue?vue&type=style&index=0&id=7476f019&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7476f019"]])

export default __exports__